import YoutubeIconDark from 'assets/images/icons/dark - youtube.svg?react';
import YoutubeIconSpringVibes from 'assets/images/icons/spring - youtube.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyYoutubeIcon = (props: IIconProps) =>
  useTemplateVariant({
    dark: () => <BaseIcon icon={YoutubeIconDark} {...props} />,
    springVibes: () => <BaseIcon icon={YoutubeIconSpringVibes} {...props} />,
    _default_: () => <i className="fa fa-youtube" style={{ color: props.color }} />,

    classic: () => <i className="fa fa-youtube" style={{ color: props.color }} />,
    simpleFiligree: () => <i className="fa fa-youtube" style={{ color: props.color }} />,
    vickyBaumannBoho: () => <i className="fa fa-youtube" style={{ color: props.color }} />,
    vickyBaumannFineart: () => <i className="fa fa-youtube" style={{ color: props.color }} />,
    breeze: () => <i className="fa fa-youtube" style={{ color: props.color }} />,
    capri: () => <i className="fa fa-youtube" style={{ color: props.color }} />,
    rose: () => <i className="fa fa-youtube" style={{ color: props.color }} />,
    calm: () => <i className="fa fa-youtube" style={{ color: props.color }} />
  })();

export const YoutubeIcon = (props: IIconProps) => (
  <SetIcon slug="youtube" fallback={LegacyYoutubeIcon} {...props} />
);
